<!--
    This component is created by LIU student group TDP032
    in our developer portal https://developer.zoezi.se/#/show/c0214d2da7db2807 -> Components -> Popup container
-->

<template>
    <div :class="popupClasses">
        <v-dialog v-model="drawer" :content-class="popupContentClass" :max-width="dynamicWidth">
            <template v-slot:activator="{ on }">
                <!-- TODO: use component warpper as component instead of v-btn - IDE-260 -->
                <v-btn
                    @click="toggleDrawer"
                    :style="computedButtonStyle"
                    :color="thin ? undefined : color"
                    :block="iconOnly ? false : block"
                    :class="{ 'zoezi-popup-button-thin': thin }"
                    :outlined="thin || outlined"
                    :loading="loading"
                    :disabled="disabled"
                    :type="type"
                    v-on="on"
                    :fab="iconOnly"
                    :x-large="size=='xLarge'"
                    :large="size=='Large'"
                >
                    <slot name="default" v-if="$scopedSlots.default" />

                    <template v-if="iconOnly">
                        <v-icon>{{ icon }}</v-icon>
                    </template>

                    <template v-else>
                        <v-icon left v-if="icon && !right">{{ icon }}</v-icon>
                        <span>{{ translatedText }}</span>
                        <v-icon right v-if="icon && right">{{ icon }}</v-icon>
                    </template>
                </v-btn>
            </template>

            <v-card>
                <v-card-title v-if="translatedHeaderText" class="headline align-start flex-column pa-2 primary primarytext--text" style="overflow-y: auto">
                    <div class="fill-width">
                        {{ translatedHeaderText }}
                        <v-btn icon @click="toggleDrawer" class="float-right"><v-icon class="primary primarytext--text">mdi-close</v-icon></v-btn>
                    </div>
                </v-card-title>
                <component-wrapper :config="saveComponents.at(0)"></component-wrapper>
            </v-card>
        </v-dialog>
        <div v-for="popup in popups" :key="popup.id"></div>
        <div v-if="$root.edit" class="popup-indicator" >
            {{ $translate("Your pop-up settings are here") }}
        </div>
    </div>
</template>

<script>
import { isHomepageFixHorizontalScrollEnabled } from '../featureFlags'

export default {
    name: "zoezi-popup-container",

    zoezi: {
        title: "Popup container",
        icon: "mdi-window-restore",
    },

    props: {
        text: {
            title: "Button text",
            type: String,
            default: "Click here",
        },

        corner: {
            title: "Pin button in the lower right corner of the screen",
            type: Boolean,
            default: false,
        },

        popupHeaderText: {
            title: "Title",
            type: String,
            default: "",
        },

        translate: {
            title: "Translate",
            type: Boolean,
            default: true,
        },

        // TODO: use zoezi-button as component in componentwrapper instead of v-btn - IDE-260
        color: {
            title: "Color",
            type: String,
            fulltype: "color",
            section: "Appearance of the button",
            default: "primary",
        },

        textColor: {
            title: "Text color",
            type: String,
            fulltype: "color",
            section: "Appearance of the button",
            default: "primarytext",
        },

        block: {
            title: "BLOCK",
            type: Boolean,
            section: "Appearance of the button",
            default: false,
        },

        thin: {
            title: "Thinner text and outlined",
            type: Boolean,
            section: "Appearance of the button",
            default: false,
        },

        outlined: {
            title: "Outlined",
            type: Boolean,
            section: "Appearance of the button",
            default: false,
        },

        icon: {
            title: "Select button icon",
            type: String,
            section: "Appearance of the button",
            fulltype: "icon",
        },

        iconOnly: {
            title: "Enable round icon button",
            type: Boolean,
            section: "Appearance of the button",
            default: false,
        },

        right: {
            title: "Icon to the right",
            type: Boolean,
            section: "Appearance of the button",
            default: false,
        },

        radius: {
            title: "Corner radius",
            type: String,
            section: "Appearance of the button",
            fulltype: "csssize",
        },

        size: {
            title: "Size",
            type: String,
            section: "Appearance of the button",
            fulltype: "select",
            typeinfo: {
                multiple: false,
                placeholder: "Select size",
                text: "name",
                value: "id",
                getItems: () => [
                    { name: "Large", id: "Large" },
                    { name: "Extra large", id: "xLarge" },
                    { name: "Medium", id: "Medium" },
                ],
            },
            default: () => "Medium",
        },

        loading: {},
        disabled: {},
        type: {},
        large: {},
        xLarge: {},

        positionX: {
            title: "Horizontal position of the window",
            type: String,
            section: "Settings for window",
            fulltype: "select",
            typeinfo: {
                multiple: false,
                placeholder: "Choose the horizontal position of the window",
                text: "name",
                value: "id",
                getItems: () => [
                    { name: "Left side of screen", id: "x-left" },
                    { name: "Middle of screen", id: "x-middle" },
                    { name: "Right side of screen", id: "x-right" },
                ],
            },
            default: () => "x-middle",
        },

        positionY: {
            title: "Vertical position of the window",
            type: String,
            section: "Settings for window",
            fulltype: "select",
            typeinfo: {
                multiple: false,
                placeholder: "Choose the vertical position of the window",
                text: "name",
                value: "id",
                getItems: () => [
                    { name: "Top of screen", id: "y-top" },
                    { name: "Middle of screen", id: "y-middle" },
                    { name: "Bottom of screen", id: "y-bottom" },
                ],
            },
            default: () => "y-middle",
        },

        width: {
            title: "Window width",
            type: String,
            section: "Settings for window",
            fulltype: "csssize",
            default: "50rem",
        },

        saveComponents: {
            title: "Field list",
            type: Array,
            section: "Component list",
            fulltype: "componentlist",
            value: "",
            typeinfo: {
                component: "zoezi-rowlayout",
                props: {},
            },
            default: () => [
                {
                    component: "zoezi-rowlayout",
                    props: {},
                },
            ],
        },
    },

    data() {
        return {
            drawer: false,
            popups: [],
            dialogStyle: {
                position: "absolute",
            },
        };
    },

    methods: {
        toggleDrawer() {
            this.drawer = !this.drawer;
        },
    },

    computed: {
        popupClasses() {
            return {
                popup: true,
                'popup-responsive': this.homepageFixHorizontalScrollEnabled
            };
        },
        popupContentClass() {
            const classes = ['popupDialog'];
            if (this.homepageFixHorizontalScrollEnabled) {
                classes.push('popupDialog-responsive');
            }
            if (this.positionX && this.positionY) {
                classes.push(this.positionX, this.positionY);
            }
            return classes.join(' ');
        },
        translatedText() {
            return this.translate ? this.$translate(this.text) : this.text;
        },
        translatedHeaderText() {
            return this.$translate(this.popupHeaderText);
        },
        computedButtonStyle() {
            let style = {};
            if (this.corner) {
                style = {
                    position: "fixed",
                    right: "20px",
                    bottom: "60px",
                };
            }
            style["border-radius"] = this.radius;

            if (!this.disabled) {
                style.color = this.$root.colorToHex(this.textColor) + " !important";
                if (this.thin) {
                    style["background-color"] = this.$root.colorToHex(this.color);
                }
            }

            return style;
        },

        dynamicWidth() {
            const screenWidth = window.innerWidth;
            const unit = this.homepageFixHorizontalScrollEnabled ? '%' : 'vw';
            if (screenWidth < 600) {
                return `90${unit}`;
            } else if (screenWidth < 768) {
                return `80${unit}`;
            } else {
                return this.width;
            }
        },
        homepageFixHorizontalScrollEnabled() {
            return isHomepageFixHorizontalScrollEnabled(this);
        },
    },
};
</script>

<style>
.popup .v-dialog__content {
    height: 80vh;
    max-height: 80vh;
}

.popup-responsive .v-btn {
    z-index: 1;
    max-width: 100%;
}

.popup-responsive .v-btn__content {
    white-space: normal;
    text-align: center;
    line-height: 1.3;
    word-break: break-word;
    width: 100%;
}

.popup-responsive .v-btn__content > span {
    display: block;
    width: 100%;
}

.popup-indicator {
    color: #000000;
    font-size: 26px;
}

.popup-header {
    text-align: center;
    font-size: 1.5em;
    padding: 20px 0;
}

.popupDialog {
    overflow: auto;
    max-height: 50rem;
    position: absolute;
}

.popupDialog.x-middle.y-middle {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

/* X position styles */
.popupDialog.x-left {
    left: 0;
}

.popupDialog.x-middle {
    left: 50%;
    transform: translateX(-50%);
}

.popupDialog.x-right {
    right: 0;
    left: auto;
}

/* Y position styles */
.popupDialog.y-top {
    top: 0;
}

.popupDialog.y-middle {
    top: 50%;
    transform: translateY(-50%);
}

.popupDialog.y-bottom {
    bottom: 0;
    top: auto;
}

@media (max-width: 600px) {
    .popup .v-dialog__content {
        height: 100vh;   /* fallback for older browsers */
        height: 100dvh;  /* visible viewport, excludes browser UI */
        max-height: 100vh;
        max-height: 100dvh;
    }

    .popupDialog {
        max-height: 90vh;   /* fallback for older browsers */
        max-height: 90dvh;  /* visible viewport, excludes browser UI */
        width: 90vw;
        overflow: auto;
    }

    .popupDialog-responsive {
        width: 90%;
    }
}
</style>
